import { schema as nSchema } from 'normalizr'
import { createAPIActions } from 'barnyard/utils';

export const NAME = 'incentives';

// IncentiveBuyers
export const INCENTIVE_BUYERS_FETCH = createAPIActions(`${NAME}/INCENTIVE_BUYERS_FETCH`);
export const INCENTIVE_BUYERS_UPDATE = createAPIActions(`${NAME}/INCENTIVE_BUYERS_UPDATE`);

// Incentives
export const REFERRAL_BUYER_INCENTIVE_FETCH = createAPIActions(`${NAME}/REFERRAL_BUYER_INCENTIVE_FETCH`);

export const IncentiveKind = {
  CHECKOUT: {
    name: 'CHECKOUT',
    value: 'Checkout',
  },
  MULTIPLE_CHECKOUTS: {
    name: 'MULTIPLE_CHECKOUTS',
    value: 'Multiple Checkouts',
  },
  MERCHANT_FEE: {
    name: 'MERCHANT_FEE',
    value: 'Merchant Fee',
  },
  AUDIENCE_ENROLLMENT: {
    name: 'AUDIENCE_ENROLLMENT',
    value: 'Audience Enrollment',
  },
  ITEM_REVIEW: {
    name: 'ITEM_REVIEW',
    value: 'Item Review',
  },
  REFERRAL: {
    name: 'REFERRAL',
    value: 'Referral',
  },
  CHECKOUT_PERCENTAGE: {
    name: 'CHECKOUT_PERCENTAGE',
    value: 'Checkout Percentage',
  },
  SUPPLIER_SYNC: {
    name: 'SUPPLIER_SYNC',
    value: 'Supplier Sync',
  },
};

const inc = new nSchema.Entity('incentives');

const incentiveBuyer = new nSchema.Entity('incentiveBuyers', {
  incentive: inc
});

export const schema = {
  inc,
  incentiveBuyer
};
